import React, { Component } from "react"
import { connect } from "react-redux"
import { Redirect } from "react-router-dom"
import { login } from "redux/ducks/User"
import UserLoginForm from "components/Form/UserLoginForm"
import glamorous from "glamorous"
import style from "utils/style"

export class LoginUser extends Component {
  state = {
    failed: false,
  }

  componentWillReceiveProps(newProps) {
    if (newProps.error && !this.state.failed) {
      this.setState({ failed: true })
    } else {
      this.setState({ failed: false })
    }
  }

  render() {
    if (this.props.loggedIn) {
      return <Redirect to="/" />
    }

    return (
      <Container>
        <UserLoginForm
          handleSubmit={this.props.login}
          hasErrors={this.state.failed}
        />
      </Container>
    )
  }
}

const mapStateToProps = state => ({
  loggedIn: state.user.loggedIn,
  loading: state.user.loading,
  error: state.user.error,
})

const mapDispatchToProps = dispatch => ({
  login: (email, password) => dispatch(login(email, password)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginUser)

const Container = glamorous.div({
  display: "flex",
  flexDirection: "column",
  background: style.colors.lightMintGreen,
  justifyContent: "center",
  alignItems: "center",
})



// WEBPACK FOOTER //
// ./src/scenes/Login/index.js